import type { VoidFunctionComponent } from 'react';
import { IconButton, icons } from '..';
import styles from './EditableMultiInputRowActions.module.less';

type Props = {
  onDelete: () => void;
  isEditing: boolean;
  toggleIsEditing: () => void;
  isNew?: boolean;
  onSave: () => void;
  isSaveDisabled: boolean;
  hasEditPermission: boolean;
};

/**
 * Component that renders the action buttons for an editable multi input row.
 * Includes edit and delete functionality.
 */
export const EditableMultiInputRowActions: VoidFunctionComponent<Props> = ({
  onDelete,
  isEditing,
  toggleIsEditing,
  isNew,
  onSave,
  isSaveDisabled,
  hasEditPermission,
}) => {
  const isEditDisabled = !hasEditPermission || isNew;
  const isDeleteDisabled = !hasEditPermission;

  const editTooltip = () => {
    if (isNew) {
      return 'You cannot edit a newly created resource.';
    }
    if (!hasEditPermission) {
      return 'Insufficient permissions to edit this resource.';
    }
    return '';
  };

  return (
    <div className={styles.tableRowActions}>
      {isEditing ? (
        <IconButton
          id="save-btn"
          icon={icons.check}
          onClick={onSave}
          isDisabled={isEditDisabled || isSaveDisabled}
          tooltip={editTooltip()}
        />
      ) : (
        <IconButton
          id="edit-btn"
          icon={icons.edit}
          onClick={toggleIsEditing}
          isDisabled={isEditDisabled}
          tooltip={editTooltip()}
        />
      )}
      <IconButton
        id="delete-btn"
        icon={icons.xMark}
        onClick={isEditing ? toggleIsEditing : onDelete}
        isDisabled={isDeleteDisabled}
        tooltip="Insufficient permissions to delete this resource"
        showTooltip={isDeleteDisabled}
      />
    </div>
  );
};
